import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import drawingDownloadMixin from "@/views/sithMesII/pds/stuffs/drawing-download-mixin";

export default {
    mixins: [emTableCheckedMixin, drawingDownloadMixin],
    computed: {
        $_rowMaterialKey() {
            return null;
        }
    },
    methods: {
        $_downloadBomDrawing() {
            if (this.$_checked && this.$_rowMaterialKey) {
                let list = this.checkedRows;
                let materials = [];
                for (let row of list) {
                    let material = row[this.$_rowMaterialKey];
                    if (this.hasCode(material)) {
                        materials.push(material);
                    }
                }
                this.batchDownloadBomDrawing(materials);
            }
        },
    }
}
